(ns motorsaif.web.svg
  (:require [motorsaif.macros :as macros]))

(def logo (macros/inline-svg "logo"))
(def bolt (macros/inline-svg "bolt"))
